<template>
  <div class="setting-content--section">
    <CarDetailsModal v-if="showCarModal" @close-modal="closeCarsModal" :carDetails="modalCarData" @carCreated="onCarCreated" @carUpdated="onCarUpdated" />

    <GekkoButton
      @click="canAddCar()"
      :text="$gettext('Add a new car')"
      icon="fa-solid fa-plus"
      class="float-right mb-3"
    />

    <div class="setting-table--wrap">
      <b-table
        id="cars-table"
        responsive
        :class="'gk-table gk-table--responsive gk-table--headed gk-table--striped gk-table--hover'"
        :items="tableItems"
        :fields="tableFields"
        :thead-class="tableHeaderClass"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :key="tableKey"
        @row-clicked="rowClicked"
        :tbody-transition-props="transProps"
        primary-key="id"
      >
        <template #cell(type_of_car)="data">
          <span v-if="data.item.company_profile" v-translate>Company car</span>
          <span v-if="!data.item.company_profile" v-translate>Private car</span>
        </template>
        <template #cell(used_from)="data">
          <span>{{data.item.used_from | formatDate}}</span>
        </template>
        <template #cell(used_until)="data">
          <span>{{data.item.used_until | formatDate}}</span>
        </template>
        <template #cell(archive_clickable)="data">
          <div @click.stop class="h-100 d-flex align-items-center justify-content-center">
            <CarArchive class="float-left mr-1" :data_object="data.item" @stop="rowClicked"></CarArchive>
          </div>
        </template>
        <template #cell(edit_clickable)>
          <span class="edit-button">{{ $gettext('edit') }}</span>
        </template>
      </b-table>
    </div>


    <p v-show="!tableItems.length" class="text-warning text-center" v-translate>You have no cars. Create a new car.</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import CarsService from "@/store/services/cars.service";
import CarDetailsModal from "@/components/trips/CarDetailsModal";
import settingsPageSetup from "@/mixins/settingsPageSetup";
import CarArchive from "@/components/trips/CarArchive";
import GekkoButton from "@/components/GekkoButton";

export default {
  name: "Cars",
  components: { CarArchive, CarDetailsModal, GekkoButton},
  mixins: [settingsPageSetup],
  data() {
    return {
      pageSettings: {
          title: this.$gettext("Your cars"),
          showCompanyPicker: true
      },
      transProps: {
        name: 'flip-list'
      },
      modalCarData: {},
      showCarModal: false,
      tableKey: 0,
      sortBy: "used_from",
      sortDesc: true,
      tableFields: [
        { key: "type_of_car", label: this.$gettext("Type of car") },
        { key: "plate_number", label: this.$gettext("Plate number"), tdClass: 'text-nowrap' },
        { key: "brand", label: this.$gettext("Brand") },
        { key: "model", label: this.$gettext("Model") },
        { key: "type", label: this.$gettext("Type") },
        { key: "odometer", label: this.$gettext("Odometer"), tdClass: 'text-right' },
        { key: "used_from", sortable: true, label: this.$gettext("Used from"), tdClass: 'text-nowrap' },
        { key: "used_until", sortable: true, label: this.$gettext("Used until"), tdClass: 'text-nowrap' },
        { key: "archive_clickable", label: ""},
        { key: "edit_clickable", label: ""}
      ],
      tableItems: []
    }
  },
  computed: {
    ...mapGetters ({ 
      currentUser: 'main/getCurrentUser',
      getCompanyId: 'main/getCompanyId'
    }),
    countUnarchived(){
      return this.tableItems.filter(element => {
        if (element.archived === false) {
          return true;
        }
        return false;
      }).length
    },
    tableHeaderClass() {
      if (!this.tableItems.length)
        return "table-header-hidden";
      else
        return "table-header-visible";
    }
  },
  created() {
    this.modalCarData = this.getDefaultCarData()
    CarsService.list({}, this.getCompanyId).then((data) => {
      this.tableItems = data;
    })
  },
  methods: {
    rowClicked(item){
      if (item.archived === false) {
        this.modalCarData = item;
        this.showCarModal = true
      } else {
        this.$store.commit('setAlert', {
          title: this.$gettext("Not allowed"),
          text: this.$gettext("Cannot edit an archived car"),
          variant: "danger",
          duration: 4
        });
      }
    },
    canAddCar() {
      var isPremium = this.$store.getters['getIsPremium'];

      if (this.countUnarchived === 0 || isPremium) {
        this.modalCarData = this.getDefaultCarData();
        this.showCarModal = true
      }
      else
        this.$store.commit('togglePremiumModal', 'web_trips_createcar');
    },
    onCarCreated(value) {
      var item = JSON.parse(JSON.stringify(value));
      this.tableItems.push(item);
    },
    onCarUpdated(value) {
      this.tableKey++;
      for(var i in this.tableItems){
        if(this.tableItems[i].id === value.id){
            this.tableItems[i] = value;
            break;
        }
      }
    },
    getDefaultCarData() {
      return {
          user: this.currentUser.id,
          company_profile: this.getCompanyId,
          plate_number: null
        };
    },
    closeCarsModal () {
      this.showCarModal = false
    }
  }
}
</script>

<style scoped lang="scss">
.edit-button {
  color: $colorBlue; /* info color */
  font-size: 75%;
}

.edit-button:hover {
  color: $colorBlue800;
}

.table-class {
  cursor: pointer;
}
</style>

<style>
table#cars-table .flip-list-move {
  transition: transform 0.3s;
}

.table-header-hidden {
  display: none;
}

.table-header-visible {
  font-size: 12px;
}
</style>